import { Navigate, useParams } from 'react-router-dom';

import { useGetCentroCosto } from '@/shared/actions/erp/administration';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveCentroCosto } from '../../components/saveCentroCosto';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateCentroCostoPageInterface {}

const UpdateCentroCostoPage: React.FC<UpdateCentroCostoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_centrocosto)
  const { id } = useParams();
  const { data, isLoading } = useGetCentroCosto(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_centro_costo) return <Navigate to="/parametrizacion/centro-costo" />;

  return <SaveCentroCosto titlePage="Editar Centro-costos" editCentroCosto={data.data} />;
};

export default UpdateCentroCostoPage;
